import { Checkbox, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ExpandButton } from "src/components/ExpandButton";
import { HighlightedText } from "src/components/HighlightedText";
import { isChecked } from "src/components/ReactiveTable/utils/groupChecked";

import { typeIcons } from "../../typeIcons";
import { AttrTransferPartStore } from "./AttrTransferPartStore";
import { AttrDetails } from "./buildAttrsList";

export const buildAttrTransColumns = (
  store: AttrTransferPartStore,
): ColumnsType<AttrDetails> => [
  {
    key: "select",
    title: <SelectHeader store={store} />,
    width: "40px",
    render: (_, row) => <SelectCell store={store} row={row} />,
    align: "center",
  },
  {
    key: "spec",
    title: "Спецификация",
    width: "20%",
    render: (_, { spec }) => spec.name,
  },
  {
    key: "attr",
    title: "Атрибут",
    width: "30%",
    render: (_, row) => <AttrCell store={store} row={row} />,
  },
  {
    key: "descr",
    title: "Описание",
    render: (_, { attr }) => attr.title,
  },
  {
    key: "type",
    title: "Тип",
    width: "140px",
    render: (_, { attr }) => (
      <Space>
        {typeIcons[attr.type.name]}
        {attr.type.name}
      </Space>
    ),
  },
];

const SelectHeader: React.FC<{ store: AttrTransferPartStore }> = observer(
  ({ store }) => {
    const value = store.topSelected;
    return (
      <Checkbox
        checked={isChecked(value)}
        indeterminate={value === "partial"}
        onClick={() => store.toggleTopSelection()}
      />
    );
  },
);

type PropsSelectCell = {
  store: AttrTransferPartStore;
  row: AttrDetails;
};
const SelectCell: React.FC<PropsSelectCell> = observer((props) => {
  const { store, row } = props;
  const state = store.selected[row.uid];
  return (
    <Checkbox
      checked={isChecked(state)}
      indeterminate={state === "partial"}
      onClick={() => store.toggleSelection(row.uid)}
    />
  );
});

type PropsAttrCell = {
  store: AttrTransferPartStore;
  row: AttrDetails;
};
const AttrCell: React.FC<PropsAttrCell> = observer((props) => {
  const {
    store,
    row: { level, attr, uid },
  } = props;
  const onCollapseToggle = () => store.toggleCollapse(uid);
  return (
    <span style={{ display: "flex" }}>
      <span style={{ width: 24 * level }} />
      <span style={{ width: 24 }}>
        {attr.type.name === "list" && (
          <ExpandButton
            collapsed={store.collapsed.has(uid)}
            onClick={onCollapseToggle}
          />
        )}
      </span>
      <HighlightedText text={attr.name} selected={store.search} />
    </span>
  );
});
